/* import __COLOCATED_TEMPLATE__ from './teammate-pending-invites-table.hbs'; */
/* RESPONSIBLE TEAM: team-email */

import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    onEditInvite: (inviteId: string) => void;
  };
}

const TeammatePendingInvitesTable = templateOnlyComponent<Signature>();
export default TeammatePendingInvitesTable;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'React::Teammates::TeammatePendingInvitesTable': typeof TeammatePendingInvitesTable;
    'react/teammates/teammate-pending-invites-table': typeof TeammatePendingInvitesTable;
  }
}
